import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { type GlowColorVariantsType } from '@/components/ui/Glow/Glow';

const colorByKind: Record<
  SpecContractType | PaidSpecContractType,
  GlowColorVariantsType
> = {
  Custom: 'blue',
  Golden: 'irrigoPurple',
  GoldenPlus: 'irrigoPurple',
  Grand: 'gold',
  GrandPlus: 'gold',
  Blitz: 'accentSec',
  BlitzPlus: 'accentSec',
};

export { colorByKind };
